import {
  SImageWrapper,
  SLink,
  SText,
  STextWrapper,
  STitle,
  SWrapperButton,
} from './GuidebookArticleCard.styled'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { ReactNode } from 'react'
import { encodeQuery } from 'utils/fetcher'
import { ButtonProps } from 'components/button/types'

export interface GuidebookArticleCardProps {
  image: ReactNode
  title: string
  description: ReactNode
  linkProps: Omit<ButtonProps, 'type'>
}

export function GuidebookArticleCard(props: GuidebookArticleCardProps) {
  const { t } = useTranslation('eol_guide')
  const router = useRouter()

  return (
    <SWrapperButton
      type="button"
      variant="secondary"
      {...props.linkProps}
      href={encodeQuery(props.linkProps.href as string, {
        inside: router.pathname?.includes('/me/'),
      })}
    >
      <SImageWrapper>{props.image}</SImageWrapper>
      <STextWrapper>
        <STitle as="h3" variant="bodyLargeBold">
          {props.title}
        </STitle>
        <SText>{props.description}</SText>
        <SLink as="span">{t('eol_guide.step_5.item_5.article_card_button')}</SLink>
      </STextWrapper>
    </SWrapperButton>
  )
}
